import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { DataUtils } from "../../common/views/DataUtils";
import { CustomerModel } from "../models/CustomerModel";
import { CustomerService } from "../services/CustomerService";

export function useCustomerVM() {
    const customerService = new CustomerService();

    const [customer, setCustomer] = useState<CustomerModel | null>(null);

    const get = () => {
        setCustomer(null);

        const request = customerService.get();
        DataUtils.onRequest(request, onResult);
    }

    const onResult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success && result.data) {
            setCustomer(result.data);
        }
    }

    return {
        customer,
        get
    }
}